import React from 'react'
import Flow from './Flow'
import Team from './Team'
const FAQ = () => {
  return (
    <>
    <Team/>
    <Flow />
    
    </>
  )
}

export default FAQ
